import {
  ArrayInput,
  Button,
  FormDataConsumer,
  maxLength,
  NumberInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { CurriculumItemTypes } from "utils/constants";
import { CurriculumItemTypeChoices } from "utils/choices";
import { specialistRequests } from "api/specialistApi";

const AddModuleItemsDialog = ({ curriculumId, moduleId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      items: (data.items || []).map(item => ({
        type: item.type,
        nameBg: item.nameBg,
        nameEn: item.nameEn,
        moduleId,
        durationHours: item.durationHours,
      })),
    };

    await dataProvider.customRequest(specialistRequests.addCurriculumItems(curriculumId), payload, "POST");
    notify("Успешно добавени теми", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добави теми към модула"
      dialogSize="md"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добави теми"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ mt: 2 }}
        />
      }
    >
      <ArrayInput
        source="items"
        label="Теми"
        defaultValue={[{}]}
      >
        <SimpleFormIterator>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextInput
                source="nameBg"
                label="Наименование (БГ)"
                validate={[required(), maxLength(500)]}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextInput
                source="nameEn"
                label="Наименование (EN)"
                validate={[required(), maxLength(500)]}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <SelectInput
                source="type"
                label="Тип"
                choices={CurriculumItemTypeChoices}
                emptyText={false}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <FormDataConsumer>
                {({ scopedFormData }) =>
                  scopedFormData?.type !== CurriculumItemTypes.Colloquium && (
                    <NumberInput
                      source="durationHours"
                      label="Часове продължителност"
                      validate={[required()]}
                      fullWidth
                      onWheel={e => e.target.blur()}
                    />
                  )
                }
              </FormDataConsumer>
            </Grid>
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default AddModuleItemsDialog;
